/**
 * Player Group Management Component
 * Componente Lit per gestire gruppi di giocatori con selezione multipla
 */

import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

// SVG Icons as template literals for Shadow DOM compatibility
const icons = {
  layerGroup: html`<svg width="16" height="16" viewBox="0 0 576 512" fill="currentColor"><path d="M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 149.8C37.4 145.8 32 137.3 32 128s5.4-17.9 13.9-21.8L264.5 5.2zM476.9 209.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2zm-152 198.2l152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0z"/></svg>`,
  edit: html`<svg width="32" height="32" viewBox="0 0 512 512" fill="currentColor"><path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"/></svg>`,
  times: html`<svg width="16" height="16" viewBox="0 0 384 512" fill="currentColor"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>`,
  plus: html`<svg width="16" height="16" viewBox="0 0 448 512" fill="currentColor"><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"/></svg>`,
  save: html`<svg width="16" height="16" viewBox="0 0 448 512" fill="currentColor"><path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"/></svg>`,
  arrowLeft: html`<svg width="16" height="16" viewBox="0 0 448 512" fill="currentColor"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg>`,
  exclamationTriangle: html`<svg width="16" height="16" viewBox="0 0 512 512" fill="currentColor"><path d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/></svg>`,
  trash: html`<svg width="32" height="32" viewBox="0 0 448 512" fill="currentColor"><path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"/></svg>`,
  users: html`<svg width="16" height="16" viewBox="0 0 640 512" fill="currentColor"><path d="M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31.4 3.5 45.2 9.8c-1.3 7.2-1.9 14.7-1.9 22.2c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.2c13.8-6.3 29.3-9.8 45.2-9.8h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z"/></svg>`,
  tag: html`<svg width="16" height="16" viewBox="0 0 448 512" fill="currentColor"><path d="M0 80V229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/></svg>`,
  alignLeft: html`<svg width="16" height="16" viewBox="0 0 448 512" fill="currentColor"><path d="M288 64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32H256c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H256c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"/></svg>`,
  palette: html`<svg width="16" height="16" viewBox="0 0 512 512" fill="currentColor"><path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/></svg>`,
  check: html`<svg width="16" height="16" viewBox="0 0 448 512" fill="currentColor"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>`,
  checkDouble: html`<svg width="16" height="16" viewBox="0 0 512 512" fill="currentColor"><path d="M342.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 178.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l160-160zm96 128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 306.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l80 80c12.5 12.5 32.8 12.5 45.3 0l160-160z"/></svg>`,
  search: html`<svg width="16" height="16" viewBox="0 0 512 512" fill="currentColor"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>`
};

interface Player {
    id: number;
    display_name: string;
    status: string;
    skill_level: string;
    skill_level_display?: string;
}

interface PlayerGroup {
    id: number;
    name: string;
    description: string;
    color: string;
    icon: string;
    player_count: number;
    active_player_count: number;
    players: Player[];
    created_at: string;
    updated_at: string;
}

interface ColorOption {
    value: string;
    label: string;
    class: string;
}

@customElement('pm-player-groups-modal')
export class PmPlayerGroupsModal extends LitElement {
    @property({ type: Boolean, reflect: true }) open = false;
    @property({ type: String }) mode: 'list' | 'create' | 'edit' = 'list';
    @property({ type: Number }) editGroupId?: number;
    
    @state() private groups: PlayerGroup[] = [];
    @state() private availablePlayers: Player[] = [];
    @state() private selectedPlayerIds: Set<number> = new Set();
    @state() private currentGroup: PlayerGroup | undefined = undefined;
    @state() private loading = false;
    @state() private error = '';
    @state() private searchQuery = '';
    @state() private filterSkillLevel = '';
    
    private modalInstance: any = null;
    private themeObserver: MutationObserver | null = null;
    
    // Form fields
    @state() private formName = '';
    @state() private formDescription = '';
    @state() private formColor = 'primary';

    private colorOptions: ColorOption[] = [
        { value: 'primary', label: 'Blu', class: 'bg-primary' },
        { value: 'success', label: 'Verde', class: 'bg-success' },
        { value: 'danger', label: 'Rosso', class: 'bg-danger' },
        { value: 'warning', label: 'Giallo', class: 'bg-warning' },
        { value: 'info', label: 'Azzurro', class: 'bg-info' },
        { value: 'secondary', label: 'Grigio', class: 'bg-secondary' },
        { value: 'dark', label: 'Nero', class: 'bg-dark' },
        { value: 'purple', label: 'Viola', class: 'bg-purple' },
        { value: 'pink', label: 'Rosa', class: 'bg-pink' },
        { value: 'orange', label: 'Arancione', class: 'bg-orange' },
    ];

    static styles = css`
        /* SVG Icon styles */
        svg {
            display: inline-block;
            vertical-align: middle;
            width: 16px;
            height: 16px;
        }

        .me-1 svg {
            margin-right: 0.25rem;
        }

        .me-2 svg {
            margin-right: 0.5rem;
        }

        .ms-2 svg {
            margin-left: 0.5rem;
        }

        :host {
            display: none;
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1055;
            overflow: hidden;
        }

        :host([open]) {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .modal-backdrop {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            z-index: 1;
            animation: fadeIn 0.15s ease-in;
        }

        @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
        }

        @keyframes slideDown {
            from {
                opacity: 0;
                transform: translateY(-50px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }

        .modal-dialog {
            position: relative;
            z-index: 2;
            width: 90%;
            max-width: 1200px;
            max-height: 90vh;
            margin: 1.75rem auto;
            animation: slideDown 0.3s ease-out;
        }

        .modal-content {
            position: relative;
            display: flex;
            flex-direction: column;
            width: 100%;
            background-color: #fff;
            border: 1px solid rgba(0, 0, 0, 0.2);
            border-radius: 0.5rem;
            box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
            max-height: 90vh;
        }

        .modal-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 1rem;
            border-bottom: 1px solid #dee2e6;
            border-top-left-radius: 0.5rem;
            border-top-right-radius: 0.5rem;
        }

        .modal-title {
            margin: 0;
            font-size: 1.25rem;
            font-weight: 500;
            line-height: 1.5;
        }

        .btn-close {
            padding: 0.5rem;
            background: transparent;
            border: 0;
            font-size: 1.5rem;
            font-weight: 700;
            line-height: 1;
            color: #000;
            opacity: 0.5;
            cursor: pointer;
        }

        .btn-close:hover {
            opacity: 0.75;
        }

        .modal-body {
            position: relative;
            flex: 1 1 auto;
            padding: 1rem;
            overflow-y: auto;
            max-height: calc(90vh - 150px);
        }

        .group-card {
            border: 2px solid var(--bs-border-color);
            border-radius: 0.5rem;
            padding: 1rem;
            margin-bottom: 1rem;
            transition: all 0.2s;
            cursor: pointer;
        }

        .group-card:hover {
            border-color: var(--bs-primary);
            box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        }

        .group-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 0.5rem;
        }

        .group-badge {
            display: inline-flex;
            align-items: center;
            gap: 0.5rem;
            padding: 0.25rem 0.75rem;
            border-radius: 1rem;
            font-size: 1.875rem;
            color: white;
        }

        .player-checkbox {
            display: flex;
            align-items: center;
            padding: 0.75rem;
            border: 1px solid var(--bs-border-color);
            border-radius: 0.375rem;
            margin-bottom: 0.5rem;
            cursor: pointer;
            transition: all 0.2s;
            width: 97%;
        }

        .player-checkbox:hover {
            background-color: var(--bs-light);
        }

        .player-checkbox.selected {
            background-color: var(--bs-primary-bg-subtle);
            border-color: var(--bs-primary);
        }

        .player-checkbox input[type="checkbox"] {
            margin-right: 0.75rem;
            cursor: pointer;
        }

        .player-info {
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .skill-badge {
            font-size: 0.75rem;
            padding: 0.25rem 0.5rem;
        }

        .search-box {
            position: sticky;
            top: 0;
            background: white;
            padding: 1rem 0;
            z-index: 10;
            border-bottom: 1px solid var(--bs-border-color);
            margin-bottom: 1rem;
        }

        .color-selector {
            gap: 0.5rem;
            margin-top: 0.5rem;
            display: -webkit-box;
        }

        .color-option {
            aspect-ratio: 1;
            width: 36px;
            height: 36px;
            border-radius: 0.25rem;
            cursor: pointer;
            border: 2px solid transparent;
            transition: all 0.2s;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .color-option:hover {
            transform: scale(1.05);
            border-color: rgba(0, 0, 0, 0.2);
        }

        .color-option.selected {
            border-color: #212529;
            box-shadow: 0 0 0 2px white, 0 0 0 4px #212529;
        }

        .color-option svg {
            width: 14px;
            height: 14px;
        }

        .empty-state {
            text-align: center;
            padding: 3rem 1rem;
            color: var(--bs-secondary);
        }

        .empty-state svg {
            width: 3rem;
            height: 3rem;
            margin-bottom: 1rem;
            opacity: 0.5;
        }

        .btn-group-actions {
            display: flex;
            gap: 0.5rem;
        }

        .stats-row {
            display: flex;
            gap: 1rem;
            margin-top: 0.5rem;
            font-size: 0.875rem;
            color: white;
        }

        .loading-spinner {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 3rem;
        }

        .alert {
            margin-bottom: 1rem;
        }

        .modal-footer {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 0.5rem;
            padding: 1rem;
            border-top: 1px solid #dee2e6;
            border-bottom-right-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
        }

        .btn {
            display: inline-block;
            padding: 0.375rem 0.75rem;
            font-size: 1rem;
            font-weight: 400;
            line-height: 1.5;
            text-align: center;
            text-decoration: none;
            vertical-align: middle;
            cursor: pointer;
            border: 1px solid transparent;
            border-radius: 0.375rem;
            transition: all 0.15s ease-in-out;
        }

        .btn:disabled {
            opacity: 0.65;
            cursor: not-allowed;
        }

        .btn-primary {
            color: #fff;
            background-color: #0d6efd;
            border-color: #0d6efd;
        }

        .btn-primary:hover:not(:disabled) {
            background-color: #0b5ed7;
            border-color: #0a58ca;
        }

        .btn-secondary {
            color: #fff;
            background-color: #6c757d;
            border-color: #6c757d;
        }

        .btn-secondary:hover:not(:disabled) {
            background-color: #5c636a;
            border-color: #565e64;
        }

        .btn-outline-primary {
            color: #0d6efd;
            border-color: #0d6efd;
            background-color: transparent;
        }

        .btn-outline-primary:hover:not(:disabled) {
            color: #fff;
            background-color: #0d6efd;
        }

        .btn-outline-secondary {
            color: #6c757d;
            border-color: #6c757d;
            background-color: transparent;
        }

        .btn-outline-secondary:hover:not(:disabled) {
            color: #fff;
            background-color: #6c757d;
        }

        .btn-outline-danger {
            color: #dc3545;
            border-color: #dc3545;
            background-color: transparent;
        }

        .btn-outline-danger:hover:not(:disabled) {
            color: #fff;
            background-color: #dc3545;
        }

        .btn-sm {
            padding: 0.25rem 0.5rem;
            font-size: 0.875rem;
            border-radius: 0.25rem;
        }

        .btn-group {
            display: inline-flex;
            gap: 0;
        }

        .btn-group .btn {
            border-radius: 0;
        }

        .btn-group .btn:first-child {
            border-top-left-radius: 0.375rem;
            border-bottom-left-radius: 0.375rem;
        }

        .btn-group .btn:last-child {
            border-top-right-radius: 0.375rem;
            border-bottom-right-radius: 0.375rem;
        }

        .form-label {
            display: inline-block;
            margin-bottom: 0.5rem;
            font-weight: 500;
        }

        .form-control, .form-select {
            display: block;
            width: 97%;
            padding: 0.375rem 0.75rem;
            font-size: 1rem;
            font-weight: 400;
            line-height: 1.5;
            color: #212529;
            background-color: #fff;
            border: 1px solid #ced4da;
            border-radius: 0.375rem;
            transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        }

        .form-control:focus, .form-select:focus {
            color: #212529;
            background-color: #fff;
            border-color: #86b7fe;
            outline: 0;
            box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
        }

        textarea.form-control {
            min-height: calc(1.5em + 0.75rem + 2px);
        }

        .badge {
            display: inline-block;
            padding: 0.35em 0.65em;
            font-size: 0.75em;
            font-weight: 700;
            line-height: 1;
            color: #fff;
            text-align: center;
            white-space: nowrap;
            vertical-align: baseline;
            border-radius: 0.375rem;
        }

        .bg-primary { background-color: #0d6efd !important; }
        .bg-success { background-color: #198754 !important; }
        .bg-danger { background-color: #dc3545 !important; }
        .bg-warning { background-color: #ffc107 !important; color: #000 !important; }
        .bg-info { background-color: #0dcaf0 !important; color: #000 !important; }
        .bg-secondary { background-color: #6c757d !important; }
        .bg-dark { background-color: #212529 !important; }
        .bg-purple { background-color: #6f42c1 !important; }
        .bg-pink { background-color: #d63384 !important; }
        .bg-orange { background-color: #fd7e14 !important; }

        .text-danger { color: #dc3545 !important; }
        .text-muted { color: #6c757d !important; }
        .text-warning { color: #ffc107 !important; }

        .spinner-border {
            display: inline-block;
            width: 2rem;
            height: 2rem;
            vertical-align: -0.125em;
            border: 0.25em solid currentColor;
            border-right-color: transparent;
            border-radius: 50%;
            animation: spinner-border 0.75s linear infinite;
        }

        @keyframes spinner-border {
            to { transform: rotate(360deg); }
        }

        .visually-hidden {
            position: absolute !important;
            width: 1px !important;
            height: 1px !important;
            padding: 0 !important;
            margin: -1px !important;
            overflow: hidden !important;
            clip: rect(0, 0, 0, 0) !important;
            white-space: nowrap !important;
            border: 0 !important;
        }

        /* Utility classes */
        .d-flex { display: flex !important; }
        .flex-column { flex-direction: column !important; }
        .align-items-center { align-items: center !important; }
        .justify-content-between { justify-content: space-between !important; }
        .justify-content-center { justify-content: center !important; }
        .gap-2 { gap: 0.5rem !important; }
        .mb-0 { margin-bottom: 0 !important; }
        .mb-1 { margin-bottom: 0.25rem !important; }
        .mb-2 { margin-bottom: 0.5rem !important; }
        .mb-3 { margin-bottom: 1rem !important; }
        .mb-4 { margin-bottom: 1.5rem !important; }
        .me-1 { margin-right: 0.25rem !important; }
        .me-2 { margin-right: 0.5rem !important; }
        .ms-2 { margin-left: 0.5rem !important; }
        .ms-3 { margin-left: 1rem !important; }
        .py-2 { padding-top: 0.5rem !important; padding-bottom: 0.5rem !important; }
        .py-3 { padding-top: 1rem !important; padding-bottom: 1rem !important; }
        .px-3 { padding-left: 1rem !important; padding-right: 1rem !important; }
        .w-100 { width: 100% !important; }
        .text-center { text-align: center !important; }
        .small { font-size: 0.875em !important; }
        
        .row {
            display: flex;
            flex-wrap: wrap;
            margin-right: -0.75rem;
            margin-left: -0.75rem;
        }

        .col-md-8, .col-md-4 {
            padding-right: 0.75rem;
            padding-left: 0.75rem;
        }

        .col-md-8 { flex: 0 0 auto; width: 66.666667%; }
        .col-md-4 { flex: 0 0 auto; width: 33.333333%; }

        @media (max-width: 768px) {
            .col-md-8, .col-md-4 {
                width: 100%;
            }
        }

        /* Dark mode support */
        :host([data-bs-theme="dark"]) .modal-content {
            background-color: #2b2b2b;
            border-color: #495057;
            color: #ffffff;
        }

        :host([data-bs-theme="dark"]) .modal-header {
            border-bottom-color: #495057;
        }

        :host([data-bs-theme="dark"]) .modal-footer {
            border-top-color: #495057;
        }

        :host([data-bs-theme="dark"]) .btn-close {
            color: #ffffff;
            opacity: 0.8;
        }

        :host([data-bs-theme="dark"]) .btn-close:hover {
            opacity: 1;
        }

        :host([data-bs-theme="dark"]) .group-card {
            background-color: #343a40;
            border-color: #495057;
        }

        :host([data-bs-theme="dark"]) .group-card:hover {
            border-color: #0d6efd;
            box-shadow: 0 4px 12px rgba(0,0,0,0.3);
        }

        :host([data-bs-theme="dark"]) .player-checkbox {
            background-color: #343a40;
            border-color: #495057;
            color: #ffffff;
        }

        :host([data-bs-theme="dark"]) .player-checkbox:hover {
            background-color: #495057;
        }

        :host([data-bs-theme="dark"]) .player-checkbox.selected {
            background-color: #0d6efd20;
            border-color: #0d6efd;
        }

        :host([data-bs-theme="dark"]) .form-control,
        :host([data-bs-theme="dark"]) .form-select {
            background-color: #495057;
            border-color: #6c757d;
            color: #ffffff;
        }

        :host([data-bs-theme="dark"]) .form-control:focus,
        :host([data-bs-theme="dark"]) .form-select:focus {
            background-color: #495057;
            border-color: #86b7fe;
            color: #ffffff;
            box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
        }

        :host([data-bs-theme="dark"]) .form-control::placeholder {
            color: #adb5bd;
        }

        :host([data-bs-theme="dark"]) .search-box {
            background-color: #2b2b2b;
            border-bottom-color: #495057;
        }

        :host([data-bs-theme="dark"]) .empty-state {
            color: #adb5bd;
        }

        :host([data-bs-theme="dark"]) .text-muted {
            color: #adb5bd !important;
        }

        :host([data-bs-theme="dark"]) .text-secondary {
            color: #adb5bd !important;
        }

        :host([data-bs-theme="dark"]) .color-option:hover {
            border-color: rgba(255, 255, 255, 0.3);
        }

        :host([data-bs-theme="dark"]) .color-option.selected {
            border-color: #ffffff;
            box-shadow: 0 0 0 2px #2b2b2b, 0 0 0 4px #ffffff;
        }

        :host([data-bs-theme="dark"]) .alert-danger {
            background-color: #842029;
            border-color: #b02a37;
            color: #ea868f;
        }

        :host([data-bs-theme="dark"]) .btn-primary {
            background-color: #0d6efd;
            border-color: #0d6efd;
            color: #ffffff;
        }

        :host([data-bs-theme="dark"]) .btn-primary:hover:not(:disabled) {
            background-color: #0b5ed7;
            border-color: #0a58ca;
        }

        :host([data-bs-theme="dark"]) .btn-secondary {
            background-color: #6c757d;
            border-color: #6c757d;
            color: #ffffff;
        }

        :host([data-bs-theme="dark"]) .btn-secondary:hover:not(:disabled) {
            background-color: #5c636a;
            border-color: #565e64;
        }

        :host([data-bs-theme="dark"]) .btn-outline-primary {
            color: #86b7fe;
            border-color: #86b7fe;
            background-color: transparent;
        }

        :host([data-bs-theme="dark"]) .btn-outline-primary:hover:not(:disabled) {
            color: #000;
            background-color: #86b7fe;
        }

        :host([data-bs-theme="dark"]) .btn-outline-secondary {
            color: #adb5bd;
            border-color: #adb5bd;
            background-color: transparent;
        }

        :host([data-bs-theme="dark"]) .btn-outline-secondary:hover:not(:disabled) {
            color: #000;
            background-color: #adb5bd;
        }

        :host([data-bs-theme="dark"]) .btn-outline-danger {
            color: #ea868f;
            border-color: #ea868f;
            background-color: transparent;
        }

        :host([data-bs-theme="dark"]) .btn-outline-danger:hover:not(:disabled) {
            color: #000;
            background-color: #ea868f;
        }

        /* Media query for system dark mode preference - SOLO se non è esplicitamente light */
        @media (prefers-color-scheme: dark) {
            :host:not([data-bs-theme="light"]) .modal-content {
                background-color: #2b2b2b;
                border-color: #495057;
                color: #ffffff;
            }

            :host:not([data-bs-theme="light"]) .modal-header {
                border-bottom-color: #495057;
            }

            :host:not([data-bs-theme="light"]) .modal-footer {
                border-top-color: #495057;
            }

            :host:not([data-bs-theme="light"]) .btn-close {
                color: #ffffff;
                opacity: 0.8;
            }

            :host:not([data-bs-theme="light"]) .group-card {
                background-color: #343a40;
                border-color: #495057;
            }

            :host:not([data-bs-theme="light"]) .player-checkbox {
                background-color: #343a40;
                border-color: #495057;
                color: #ffffff;
            }

            :host:not([data-bs-theme="light"]) .form-control,
            :host:not([data-bs-theme="light"]) .form-select {
                background-color: #495057;
                border-color: #6c757d;
                color: #ffffff;
            }

            :host:not([data-bs-theme="light"]) .search-box {
                background-color: #2b2b2b;
                border-bottom-color: #495057;
            }

            :host:not([data-bs-theme="light"]) .text-muted {
                color: #adb5bd !important;
            }
        }
    `;

    connectedCallback() {
        super.connectedCallback();
        this.loadGroups();
        this.loadAvailablePlayers();
        
        // Listener per chiudere con ESC
        this.handleEscKey = this.handleEscKey.bind(this);
        
        // Sincronizza tema con documento
        this.syncTheme();
        
        // Observer per cambiamenti del tema
        this.themeObserver = new MutationObserver(() => {
            this.syncTheme();
        });
        
        this.themeObserver.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['data-bs-theme']
        });
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener('keydown', this.handleEscKey);
        
        // Cleanup theme observer
        if (this.themeObserver) {
            this.themeObserver.disconnect();
            this.themeObserver = null;
        }
    }

    updated(changedProperties: Map<string, any>) {
        // Gestisci l'apertura/chiusura quando cambia la proprietà 'open'
        if (changedProperties.has('open')) {
            if (this.open) {
                document.addEventListener('keydown', this.handleEscKey);
                document.body.style.overflow = 'hidden';
            } else {
                document.removeEventListener('keydown', this.handleEscKey);
                document.body.style.overflow = '';
            }
        }
    }

    private handleEscKey(e: KeyboardEvent) {
        if (e.key === 'Escape' && this.open) {
            this.closeModal();
        }
    }

    private syncTheme() {
        const documentTheme = document.documentElement.getAttribute('data-bs-theme');
        if (documentTheme) {
            this.setAttribute('data-bs-theme', documentTheme);
        } else {
            this.removeAttribute('data-bs-theme');
        }
    }

    private handleBackdropClick(e: MouseEvent) {
        // Chiudi solo se si clicca sul backdrop, non sul contenuto
        if (e.target === e.currentTarget) {
            this.closeModal();
        }
    }

    public openModal() {
        this.open = true;
        this.syncTheme(); // Assicurati che il tema sia sincronizzato quando si apre
        this.requestUpdate();
    }

    public closeModal() {
        this.open = false;
        this.dispatchEvent(new CustomEvent('modal-closed', { bubbles: true, composed: true }));
    }

    private async loadGroups() {
        this.loading = true;
        this.error = '';
        
        try {
            const response = await fetch('/simulations/api/player-groups/');
            if (!response.ok) throw new Error('Errore nel caricamento dei gruppi');
            
            const data = await response.json();
            this.groups = data.groups;
        } catch (err) {
            this.error = err instanceof Error ? err.message : 'Errore sconosciuto';
        } finally {
            this.loading = false;
        }
    }

    private async loadAvailablePlayers() {
        try {
            const response = await fetch('/simulations/api/players/available/');
            if (!response.ok) throw new Error('Errore nel caricamento dei giocatori');
            
            const data = await response.json();
            this.availablePlayers = data.players;
        } catch (err) {
            console.error('Errore caricamento giocatori:', err);
        }
    }

    private async loadGroupDetails(groupId: number) {
        this.loading = true;
        try {
            const response = await fetch(`/simulations/api/player-groups/${groupId}/`);
            if (!response.ok) throw new Error('Errore nel caricamento del gruppo');
            
            this.currentGroup = await response.json();
            this.formName = this.currentGroup!.name;
            this.formDescription = this.currentGroup!.description;
            this.formColor = this.currentGroup!.color;
            this.selectedPlayerIds = new Set(this.currentGroup!.players.map(p => p.id));
        } catch (err) {
            this.error = err instanceof Error ? err.message : 'Errore sconosciuto';
        } finally {
            this.loading = false;
        }
    }

    private async createGroup() {
        if (!this.formName.trim()) {
            this.error = 'Il nome del gruppo è obbligatorio';
            return;
        }

        this.loading = true;
        this.error = '';

        try {
            const response = await fetch('/simulations/api/player-groups/create/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': this.getCSRFToken(),
                },
                body: JSON.stringify({
                    name: this.formName,
                    description: this.formDescription,
                    color: this.formColor,
                    icon: '',
                    player_ids: Array.from(this.selectedPlayerIds),
                }),
            });

            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.error || 'Errore nella creazione del gruppo');
            }

            await this.loadGroups();
            this.resetForm();
            this.mode = 'list';
            this.dispatchEvent(new CustomEvent('group-created', { bubbles: true, composed: true }));
        } catch (err) {
            this.error = err instanceof Error ? err.message : 'Errore sconosciuto';
        } finally {
            this.loading = false;
        }
    }

    private async updateGroup() {
        if (!this.currentGroup || !this.formName.trim()) {
            this.error = 'Dati non validi';
            return;
        }

        this.loading = true;
        this.error = '';

        try {
            const response = await fetch(`/simulations/api/player-groups/${this.currentGroup.id}/update/`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': this.getCSRFToken(),
                },
                body: JSON.stringify({
                    name: this.formName,
                    description: this.formDescription,
                    color: this.formColor,
                    icon: '',
                    player_ids: Array.from(this.selectedPlayerIds),
                }),
            });

            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.error || 'Errore nell\'aggiornamento del gruppo');
            }

            await this.loadGroups();
            this.resetForm();
            this.mode = 'list';
            this.dispatchEvent(new CustomEvent('group-updated', { bubbles: true, composed: true }));
        } catch (err) {
            this.error = err instanceof Error ? err.message : 'Errore sconosciuto';
        } finally {
            this.loading = false;
        }
    }

    private async deleteGroup(groupId: number, groupName: string) {
        if (!confirm(`Sei sicuro di voler eliminare il gruppo "${groupName}"?`)) {
            return;
        }

        this.loading = true;
        this.error = '';

        try {
            const response = await fetch(`/simulations/api/player-groups/${groupId}/delete/`, {
                method: 'POST',
                headers: {
                    'X-CSRFToken': this.getCSRFToken(),
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                // Tenta di parsare come JSON, altrimenti usa messaggio generico
                let errorMessage = 'Errore nell\'eliminazione del gruppo';
                try {
                    const contentType = response.headers.get('content-type');
                    if (contentType && contentType.includes('application/json')) {
                        const data = await response.json();
                        errorMessage = data.error || errorMessage;
                    } else {
                        const text = await response.text();
                        console.error('Response non-JSON:', text);
                        errorMessage = `Errore HTTP ${response.status}: ${response.statusText}`;
                    }
                } catch (parseError) {
                    console.error('Errore parsing risposta:', parseError);
                }
                throw new Error(errorMessage);
            }

            // Verifica che la risposta sia JSON prima di parsare
            const contentType = response.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
                await response.json(); // Consuma la risposta ma non la usiamo
            }

            await this.loadGroups();
            this.dispatchEvent(new CustomEvent('group-deleted', { bubbles: true, composed: true }));
        } catch (err) {
            console.error('Errore eliminazione gruppo:', err);
            this.error = err instanceof Error ? err.message : 'Errore sconosciuto';
        } finally {
            this.loading = false;
        }
    }

    private togglePlayerSelection(playerId: number) {
        if (this.selectedPlayerIds.has(playerId)) {
            this.selectedPlayerIds.delete(playerId);
        } else {
            this.selectedPlayerIds.add(playerId);
        }
        this.requestUpdate();
    }

    private selectAllPlayers() {
        const filtered = this.getFilteredPlayers();
        filtered.forEach(player => this.selectedPlayerIds.add(player.id));
        this.requestUpdate();
    }

    private deselectAllPlayers() {
        this.selectedPlayerIds.clear();
        this.requestUpdate();
    }

    private getFilteredPlayers(): Player[] {
        return this.availablePlayers.filter(player => {
            const matchesSearch = !this.searchQuery || 
                player.display_name.toLowerCase().includes(this.searchQuery.toLowerCase());
            const matchesSkill = !this.filterSkillLevel || 
                player.skill_level === this.filterSkillLevel;
            return matchesSearch && matchesSkill;
        });
    }

    private resetForm() {
        this.formName = '';
        this.formDescription = '';
        this.formColor = 'primary';
        this.selectedPlayerIds.clear();
        this.currentGroup = undefined;
        this.error = '';
        this.searchQuery = '';
        this.filterSkillLevel = '';
    }

    private getCSRFToken(): string {
        const token = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ||
                     document.querySelector<HTMLInputElement>('[name=csrfmiddlewaretoken]')?.value;
        return token || '';
    }

    private handleEditGroup(group: PlayerGroup) {
        this.editGroupId = group.id;
        this.mode = 'edit';
        this.loadGroupDetails(group.id);
    }

    private handleBackToList() {
        this.mode = 'list';
        this.resetForm();
    }

    private handleModalClose() {
        this.closeModal();
    }

    render() {
        if (!this.open) return html``;

        return html`
            <div class="modal-backdrop" @click=${this.handleBackdropClick}>
                <div class="modal-dialog">
                    <div class="modal-content" @click=${(e: Event) => e.stopPropagation()}>
                        ${this.renderModalHeader()}
                        ${this.renderModalBody()}
                        ${this.renderModalFooter()}
                    </div>
                </div>
            </div>
        `;
    }

    private renderModalHeader() {
        const titles = {
            list: 'Gestione Gruppi Giocatori',
            create: 'Crea Nuovo Gruppo',
            edit: 'Modifica Gruppo'
        };

        return html`
            <div class="modal-header">
                <h5 class="modal-title">
                    <span class="me-2">${this.mode === 'list' ? icons.layerGroup : icons.edit}</span>
                    ${titles[this.mode]}
                </h5>
                <button type="button" class="btn-close" aria-label="Chiudi" @click=${this.handleModalClose}>×</button>
            </div>
        `;
    }

    private renderModalBody() {
        if (this.loading) {
            return html`
                <div class="modal-body">
                    <div class="loading-spinner">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Caricamento...</span>
                        </div>
                    </div>
                </div>
            `;
        }

        return html`
            <div class="modal-body">
                ${this.error ? html`
                    <div class="alert alert-danger alert-dismissible fade show" role="alert">
                        <span class="me-2">${icons.exclamationTriangle}</span>
                        ${this.error}
                        <button type="button" class="btn-close" @click=${() => this.error = ''}></button>
                    </div>
                ` : ''}

                ${this.mode === 'list' ? this.renderGroupsList() : this.renderGroupForm()}
            </div>
        `;
    }

    private renderModalFooter() {
        if (this.mode === 'list') {
            return html`
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click=${this.handleModalClose}>
                        <span class="me-2">${icons.times}</span>Chiudi
                    </button>
                    <button type="button" class="btn btn-primary" @click=${() => this.mode = 'create'}>
                        <span class="me-2">${icons.plus}</span>Crea Nuovo Gruppo
                    </button>
                </div>
            `;
        }

        return html`
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" @click=${this.handleBackToList}>
                    <span class="me-2">${icons.arrowLeft}</span>Indietro
                </button>
                <button 
                    type="button" 
                    class="btn btn-primary"
                    @click=${this.mode === 'create' ? this.createGroup : this.updateGroup}
                    ?disabled=${this.loading}
                >
                    <span class="me-2">${this.mode === 'create' ? icons.plus : icons.save}</span>
                    ${this.mode === 'create' ? 'Crea Gruppo' : 'Salva Modifiche'}
                </button>
            </div>
        `;
    }

    private renderGroupsList() {
        if (this.groups.length === 0) {
            return html`
                <div class="empty-state">
                    ${icons.layerGroup}
                    <h4>Nessun gruppo creato</h4>
                    <p class="text-muted">Crea il tuo primo gruppo per organizzare i giocatori</p>
                </div>
            `;
        }

        return html`
            <div class="groups-list">
                ${this.groups.map(group => html`
                    <div class="group-card bg-${group.color}">
                        <div class="group-header">
                            <div>
                                <span class="group-badge ">
                                    <strong>${group.name}</strong>
                                </span>
                            </div>
                            <div class="btn-group-actions">
                                <button 
                                    class="btn btn-sm btn-outline-primary"
                                    @click=${() => this.handleEditGroup(group)}
                                >
                                    ${icons.edit}
                                </button>
                                <button 
                                    class="btn btn-sm btn-outline-danger"
                                    @click=${() => this.deleteGroup(group.id, group.name)}
                                >
                                    ${icons.trash}
                                </button>
                            </div>
                        </div>
                        
                        ${group.description ? html`
                            <p class="text-muted small mb-2">${group.description}</p>
                        ` : ''}
                        
                        <div class="stats-row">
                            <span>
                                <span class="me-1">${icons.users}</span>
                                ${group.active_player_count} giocatori attivi
                            </span>
                            ${group.player_count !== group.active_player_count ? html`
                                <span class="text-warning">
                                    <span class="me-1">${icons.exclamationTriangle}</span>
                                    ${group.player_count - group.active_player_count} non attivi
                                </span>
                            ` : ''}
                        </div>
                    </div>
                `)}
            </div>
        `;
    }

    private renderGroupForm() {
        const filteredPlayers = this.getFilteredPlayers();
        const selectedCount = this.selectedPlayerIds.size;

        return html`
            <div class="group-form">
                <!-- Nome gruppo -->
                <div class="mb-3">
                    <label class="form-label">
                        <span class="me-1">${icons.tag}</span>
                        Nome Gruppo <span class="text-danger">*</span>
                    </label>
                    <input 
                        type="text" 
                        class="form-control" 
                        .value=${this.formName}
                        @input=${(e: InputEvent) => this.formName = (e.target as HTMLInputElement).value}
                        placeholder="Es: Serie A, Principianti, Torneo Estivo..."
                    />
                </div>

                <!-- Descrizione -->
                <div class="mb-3">
                    <label class="form-label">
                        <span class="me-1">${icons.alignLeft}</span>
                        Descrizione (opzionale)
                    </label>
                    <textarea 
                        class="form-control" 
                        rows="2"
                        .value=${this.formDescription}
                        @input=${(e: InputEvent) => this.formDescription = (e.target as HTMLTextAreaElement).value}
                        placeholder="Descrizione del gruppo..."
                    ></textarea>
                </div>

                <!-- Colore -->
                <div class="mb-3">
                    <label class="form-label">
                        <span class="me-1">${icons.palette}</span>
                        Colore Identificativo
                    </label>
                    <div class="color-selector">
                        ${this.colorOptions.map(color => html`
                            <div 
                                class="color-option ${color.class} ${this.formColor === color.value ? 'selected' : ''}"
                                @click=${() => this.formColor = color.value}
                                title=${color.label}
                            >
                                ${this.formColor === color.value ? html`<span class="text-white">${icons.check}</span>` : ''}
                            </div>
                        `)}
                    </div>
                </div>

                <!-- Selezione giocatori -->
                <div class="mb-3">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <label class="form-label mb-0">
                            <span class="me-1">${icons.users}</span>
                            Seleziona Giocatori
                            ${selectedCount > 0 ? html`
                                <span class="badge bg-primary ms-2">${selectedCount} selezionati</span>
                            ` : ''}
                        </label>
                        <div class="btn-group btn-group-sm">
                            <button 
                                type="button" 
                                class="btn btn-outline-primary"
                                @click=${this.selectAllPlayers}
                            >
                                <span class="me-1">${icons.checkDouble}</span>Tutti
                            </button>
                            <button 
                                type="button" 
                                class="btn btn-outline-secondary"
                                @click=${this.deselectAllPlayers}
                            >
                                <span class="me-1">${icons.times}</span>Nessuno
                            </button>
                        </div>
                    </div>

                    <!-- Search & Filter -->
                    <div class="search-box">
                        <div class="row g-2">
                            <div class="col-md-8">
                                <input 
                                    type="text" 
                                    class="form-control form-control-sm" 
                                    placeholder="🔍 Cerca giocatore..."
                                    .value=${this.searchQuery}
                                    @input=${(e: InputEvent) => this.searchQuery = (e.target as HTMLInputElement).value}
                                />
                            </div>
                            <div class="col-md-4">
                                <select 
                                    class="form-select form-select-sm"
                                    .value=${this.filterSkillLevel}
                                    @change=${(e: Event) => this.filterSkillLevel = (e.target as HTMLSelectElement).value}
                                >
                                    <option value="">Tutti i livelli</option>
                                    <option value="principiante">Principiante</option>
                                    <option value="intermedio">Intermedio</option>
                                    <option value="avanzato">Avanzato</option>
                                    <option value="esperto">Esperto</option>
                                    <option value="professionale">Professionale</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <!-- Lista giocatori -->
                    <div class="players-list" style="max-height: 400px; overflow-y: auto;">
                        ${filteredPlayers.length === 0 ? html`
                            <div class="text-center text-muted py-3">
                                <span class="me-2">${icons.search}</span>
                                Nessun giocatore trovato
                            </div>
                        ` : filteredPlayers.map(player => html`
                            <div 
                                class="player-checkbox ${this.selectedPlayerIds.has(player.id) ? 'selected' : ''}"
                                @click=${() => this.togglePlayerSelection(player.id)}
                            >
                                <input 
                                    type="checkbox" 
                                    .checked=${this.selectedPlayerIds.has(player.id)}
                                    @click=${(e: Event) => e.stopPropagation()}
                                    @change=${() => this.togglePlayerSelection(player.id)}
                                />
                                <div class="player-info">
                                    <span>${player.display_name}</span>
                                    <span class="badge bg-info skill-badge">
                                        ${player.skill_level_display || player.skill_level}
                                    </span>
                                </div>
                            </div>
                        `)}
                    </div>
                </div>
            </div>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'pm-player-groups-modal': PmPlayerGroupsModal;
    }
}
